export enum CourseCodeEnum {
	COURSE_CODE = 'AL-PP-01',
}